import { Injectable, signal } from '@angular/core';

/** Layout state for BrightNav feature (sidebar collapsed). Single app-wide instance (providedIn: 'root'). */
@Injectable({
  providedIn: 'root',
})
export class BrightnavLayoutService {
  collapsed = signal<boolean>(false);

  toggleCollapsed() {
    this.collapsed.set(!this.collapsed());
  }
}
